import React from 'react';
import { DashboardLayout } from '../components/dashboard';
import { NetworkWorkspace } from '../features/intelligence/network/NetworkWorkspace';

/** Network: relationship intelligence workspace (see docs/intelligence-workspace.md) */
export const RelationshipsPage: React.FC = () => (
  <DashboardLayout>
    <NetworkWorkspace />
  </DashboardLayout>
);

export default RelationshipsPage;
